import { useMutation, useQuery, UseMutationOptions, UseQueryOptions } from '@tanstack/react-query'
import { TUseMutationOptions, TUseQueryOptions } from 'core/query/type'
import {
  TGetUserTradingFavoriteListParams,
  TGetUserTradingFavoriteListResponse,
  getUserTradingFavoriteList,
  TGetUserBizStatusParams,
  TGetUserBizStatusResponse,
  getUserBizStatus,
  TGetUserCheckUserExistParams,
  TGetUserCheckUserExistResponse,
  getUserCheckUserExist,
  TPostUserCheckUserExistParams,
  TPostUserCheckUserExistResponse,
  postUserCheckUserExist,
  TGetUserDelWithdrawAddressParams,
  TGetUserDelWithdrawAddressResponse,
  getUserDelWithdrawAddress,
  TPostUserDelWithdrawAddressParams,
  TPostUserDelWithdrawAddressResponse,
  postUserDelWithdrawAddress,
  TGetUserGetGoogleKeyParams,
  TGetUserGetGoogleKeyResponse,
  getUserGetGoogleKey,
  TPostUserGetGoogleKeyParams,
  TPostUserGetGoogleKeyResponse,
  postUserGetGoogleKey,
  TGetUserOauthParams,
  TGetUserOauthResponse,
  getUserOauth,
  TPostUserOauthParams,
  TPostUserOauthResponse,
  postUserOauth,
  TGetUserSaveWithdrawAddressParams,
  TGetUserSaveWithdrawAddressResponse,
  getUserSaveWithdrawAddress,
  TPostUserSaveWithdrawAddressParams,
  TPostUserSaveWithdrawAddressResponse,
  postUserSaveWithdrawAddress,
  TGetUserUserFavoriteJsonParams,
  TGetUserUserFavoriteJsonResponse,
  getUserUserFavoriteJson,
  TPostUserUserFavoriteJsonParams,
  TPostUserUserFavoriteJsonResponse,
  postUserUserFavoriteJson,
  TGetUserUserLoginlogJsonParams,
  TGetUserUserLoginlogJsonResponse,
  getUserUserLoginlogJson,
  TPostUserUserLoginlogJsonParams,
  TPostUserUserLoginlogJsonResponse,
  postUserUserLoginlogJson,
  TGetUserUserSettinglogJsonParams,
  TGetUserUserSettinglogJsonResponse,
  getUserUserSettinglogJson,
  TPostUserUserSettinglogJsonParams,
  TPostUserUserSettinglogJsonResponse,
  postUserUserSettinglogJson,
  TPostUserTradingFavoriteBatchAddParams,
  TPostUserTradingFavoriteBatchAddResponse,
  postUserTradingFavoriteBatchAdd,
  TPostUserTradingFavoriteBatchCancelParams,
  TPostUserTradingFavoriteBatchCancelResponse,
  postUserTradingFavoriteBatchCancel,
} from 'core/service/yapi/hk-web/FrontUserJson/api'
// front-user-json-controller
// listTradingFavorite
export const useGetUserTradingFavoriteListQuery = (
  params?: TGetUserTradingFavoriteListParams,
  options?: TUseQueryOptions<TGetUserTradingFavoriteListResponse>
) => {
  return useQuery({
    ...options,
    queryKey: ['FrontUserJson', 'UserTradingFavoriteList', 'GET', ...Object.values(params || {})],
    queryFn: () => getUserTradingFavoriteList(params),
  })
}

// 获取用户业务状态
export const useGetUserBizStatusQuery = (
  params?: TGetUserBizStatusParams,
  options?: TUseQueryOptions<TGetUserBizStatusResponse>
) => {
  return useQuery({
    ...options,
    queryKey: ['FrontUserJson', 'UserBizStatus', 'GET', ...Object.values(params || {})],
    queryFn: () => getUserBizStatus(params),
  })
}

// chcekregname
export const useGetUserCheckUserExistQuery = (
  params?: TGetUserCheckUserExistParams,
  options?: TUseQueryOptions<TGetUserCheckUserExistResponse>
) => {
  return useQuery({
    ...options,
    queryKey: ['FrontUserJson', 'UserCheckUserExist', 'GET', ...Object.values(params || {})],
    queryFn: () => getUserCheckUserExist(params),
  })
}

// chcekregname
export const usePostUserCheckUserExistMutation = (
  mutationOptions?: TUseMutationOptions<TPostUserCheckUserExistResponse, TPostUserCheckUserExistParams>
) => {
  return useMutation({
    ...mutationOptions,
    mutationKey: ['FrontUserJson', 'UserCheckUserExist', 'Post'],
    mutationFn: (params?: TPostUserCheckUserExistParams) => postUserCheckUserExist(params),
  })
}

// detelCoinAddress
export const useGetUserDelWithdrawAddressQuery = (
  params?: TGetUserDelWithdrawAddressParams,
  options?: TUseQueryOptions<TGetUserDelWithdrawAddressResponse>
) => {
  return useQuery({
    ...options,
    queryKey: ['FrontUserJson', 'UserDelWithdrawAddress', 'GET', ...Object.values(params || {})],
    queryFn: () => getUserDelWithdrawAddress(params),
  })
}

// detelCoinAddress
export const usePostUserDelWithdrawAddressMutation = (
  mutationOptions?: TUseMutationOptions<TPostUserDelWithdrawAddressResponse, TPostUserDelWithdrawAddressParams>
) => {
  return useMutation({
    ...mutationOptions,
    mutationKey: ['FrontUserJson', 'UserDelWithdrawAddress', 'Post'],
    mutationFn: (params?: TPostUserDelWithdrawAddressParams) => postUserDelWithdrawAddress(params),
  })
}

// getGoogleTotpKey
export const useGetUserGetGoogleKeyQuery = (
  params?: TGetUserGetGoogleKeyParams,
  options?: TUseQueryOptions<TGetUserGetGoogleKeyResponse>
) => {
  return useQuery({
    ...options,
    queryKey: ['FrontUserJson', 'UserGetGoogleKey', 'GET', ...Object.values(params || {})],
    queryFn: () => getUserGetGoogleKey(params),
  })
}

// getGoogleTotpKey
export const usePostUserGetGoogleKeyMutation = (
  mutationOptions?: TUseMutationOptions<TPostUserGetGoogleKeyResponse, TPostUserGetGoogleKeyParams>
) => {
  return useMutation({
    ...mutationOptions,
    mutationKey: ['FrontUserJson', 'UserGetGoogleKey', 'Post'],
    mutationFn: (params?: TPostUserGetGoogleKeyParams) => postUserGetGoogleKey(params),
  })
}

// userOauth
export const useGetUserOauthQuery = (
  params?: TGetUserOauthParams,
  options?: TUseQueryOptions<TGetUserOauthResponse>
) => {
  return useQuery({
    ...options,
    queryKey: ['FrontUserJson', 'UserOauth', 'GET', ...Object.values(params || {})],
    queryFn: () => getUserOauth(params),
  })
}

// userOauth
export const usePostUserOauthMutation = (
  mutationOptions?: TUseMutationOptions<TPostUserOauthResponse, TPostUserOauthParams>
) => {
  return useMutation({
    ...mutationOptions,
    mutationKey: ['FrontUserJson', 'UserOauth', 'Post'],
    mutationFn: (params?: TPostUserOauthParams) => postUserOauth(params),
  })
}

// saveWithdrawBtcAddr
export const useGetUserSaveWithdrawAddressQuery = (
  params?: TGetUserSaveWithdrawAddressParams,
  options?: TUseQueryOptions<TGetUserSaveWithdrawAddressResponse>
) => {
  return useQuery({
    ...options,
    queryKey: ['FrontUserJson', 'UserSaveWithdrawAddress', 'GET', ...Object.values(params || {})],
    queryFn: () => getUserSaveWithdrawAddress(params),
  })
}

// saveWithdrawBtcAddr
export const usePostUserSaveWithdrawAddressMutation = (
  mutationOptions?: TUseMutationOptions<TPostUserSaveWithdrawAddressResponse, TPostUserSaveWithdrawAddressParams>
) => {
  return useMutation({
    ...mutationOptions,
    mutationKey: ['FrontUserJson', 'UserSaveWithdrawAddress', 'Post'],
    mutationFn: (params?: TPostUserSaveWithdrawAddressParams) => postUserSaveWithdrawAddress(params),
  })
}

// userUpdateFavorite
export const useGetUserUserFavoriteJsonQuery = (
  params?: TGetUserUserFavoriteJsonParams,
  options?: TUseQueryOptions<TGetUserUserFavoriteJsonResponse>
) => {
  return useQuery({
    ...options,
    queryKey: ['FrontUserJson', 'UserUserFavoriteJson', 'GET', ...Object.values(params || {})],
    queryFn: () => getUserUserFavoriteJson(params),
  })
}

// userUpdateFavorite
export const usePostUserUserFavoriteJsonMutation = (
  mutationOptions?: TUseMutationOptions<TPostUserUserFavoriteJsonResponse, TPostUserUserFavoriteJsonParams>
) => {
  return useMutation({
    ...mutationOptions,
    mutationKey: ['FrontUserJson', 'UserUserFavoriteJson', 'Post'],
    mutationFn: (params?: TPostUserUserFavoriteJsonParams) => postUserUserFavoriteJson(params),
  })
}

// userLoginlog
export const useGetUserUserLoginlogJsonQuery = (
  params?: TGetUserUserLoginlogJsonParams,
  options?: TUseQueryOptions<TGetUserUserLoginlogJsonResponse>
) => {
  return useQuery({
    ...options,
    queryKey: ['FrontUserJson', 'UserUserLoginlogJson', 'GET', ...Object.values(params || {})],
    queryFn: () => getUserUserLoginlogJson(params),
  })
}

// userLoginlog
export const usePostUserUserLoginlogJsonMutation = (
  mutationOptions?: TUseMutationOptions<TPostUserUserLoginlogJsonResponse, TPostUserUserLoginlogJsonParams>
) => {
  return useMutation({
    ...mutationOptions,
    mutationKey: ['FrontUserJson', 'UserUserLoginlogJson', 'Post'],
    mutationFn: (params?: TPostUserUserLoginlogJsonParams) => postUserUserLoginlogJson(params),
  })
}

// userSettinglog
export const useGetUserUserSettinglogJsonQuery = (
  params?: TGetUserUserSettinglogJsonParams,
  options?: TUseQueryOptions<TGetUserUserSettinglogJsonResponse>
) => {
  return useQuery({
    ...options,
    queryKey: ['FrontUserJson', 'UserUserSettinglogJson', 'GET', ...Object.values(params || {})],
    queryFn: () => getUserUserSettinglogJson(params),
  })
}

// userSettinglog
export const usePostUserUserSettinglogJsonMutation = (
  mutationOptions?: TUseMutationOptions<TPostUserUserSettinglogJsonResponse, TPostUserUserSettinglogJsonParams>
) => {
  return useMutation({
    ...mutationOptions,
    mutationKey: ['FrontUserJson', 'UserUserSettinglogJson', 'Post'],
    mutationFn: (params?: TPostUserUserSettinglogJsonParams) => postUserUserSettinglogJson(params),
  })
}

// batchAddTradingFavorite
export const usePostUserTradingFavoriteBatchAddMutation = (
  mutationOptions?: TUseMutationOptions<
    TPostUserTradingFavoriteBatchAddResponse,
    TPostUserTradingFavoriteBatchAddParams
  >
) => {
  return useMutation({
    ...mutationOptions,
    mutationKey: ['FrontUserJson', 'UserTradingFavoriteBatchAdd', 'Post'],
    mutationFn: (params?: TPostUserTradingFavoriteBatchAddParams) => postUserTradingFavoriteBatchAdd(params),
  })
}

// batchCancelTradingFavorite
export const usePostUserTradingFavoriteBatchCancelMutation = (
  mutationOptions?: TUseMutationOptions<
    TPostUserTradingFavoriteBatchCancelResponse,
    TPostUserTradingFavoriteBatchCancelParams
  >
) => {
  return useMutation({
    ...mutationOptions,
    mutationKey: ['FrontUserJson', 'UserTradingFavoriteBatchCancel', 'Post'],
    mutationFn: (params?: TPostUserTradingFavoriteBatchCancelParams) => postUserTradingFavoriteBatchCancel(params),
  })
}
